import React, { useState, cloneElement, useEffect } from 'react'
import { Popover, Box, Checkbox, FormControlLabel, FormGroup, Typography } from '@mui/material'

const CategoryFilterPopover = ({ trigger, categories, onSelection, startingCategories }) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const [selectedCategories, setSelectedCategories] = useState(['all'])

  useEffect(() => {
    if(startingCategories) {
      setSelectedCategories(startingCategories)
    }
  }, [startingCategories])

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleCheckboxChange = (category) => {
    let newSelection
    if (category === 'all') {
      newSelection = ['all']
    } else {
      newSelection = selectedCategories.includes('all')
        ? [category]
        : selectedCategories.includes(category)
        ? selectedCategories.filter((c) => c !== category && c !== 'all')
        : [...selectedCategories.filter((c) => c !== 'all'), category]
      if (newSelection.length === 0 || categories.length === newSelection.length) newSelection = ['all']
    }
    setSelectedCategories(newSelection)
    onSelection(newSelection)
  }

  return (
    <>
      {cloneElement(trigger, { onClick: handleClick })}
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Box sx={{ p: 1, minWidth: 200 }}>
          <Typography variant="body1" gutterBottom>
            Select Categories
          </Typography>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={selectedCategories.includes('all')}
                  onChange={() => handleCheckboxChange('all')}
                />
              }
              label="All"
            />
            {[...categories].sort((a,b) => a.localeCompare(b)).map((category) => (
              <FormControlLabel
                key={category}
                control={
                  <Checkbox
                    checked={selectedCategories.includes(category)}
                    onChange={() => handleCheckboxChange(category)}
                  />
                }
                label={category}
              />
            ))}
          </FormGroup>
        </Box>
      </Popover>
    </>
  )
}

export default CategoryFilterPopover